import { OptionType } from '@evinced-private/ui-common';

import { IMobileSdkFilterOptions } from 'src/apps/mobile-sdk/hooks/useMobileSdkFilterOptionsQuery';
import { getUniqueValues, toStringArray } from 'src/common/helpers/ArraysHelper';
import { MOBILE_SDK_TYPES_MAP, MobileSdkTypesIds } from 'src/common/helpers/MobileQueriesHelper';

import { MobileSdkFilterOptionsQuery } from '../MobileSdkFilterOptions.generated';

const naturalSort = (a: string, b: string): number => {
	return a.localeCompare(b, undefined, {
		numeric: true,
		sensitivity: 'base'
	});
};

const createSortedOptions = (values: string[]): OptionType[] => {
	return values
		.reduce<OptionType[]>((acc, value) => {
			if (value) {
				acc.push({ value, label: value });
			}
			return acc;
		}, [])
		.sort((a, b) => naturalSort(String(a.value), String(b.value)));
};

const createSdkTypeOptions = (values: string[]): OptionType[] => {
	return values
		.reduce<OptionType[]>((acc, sdkType) => {
			if (Boolean(sdkType) && sdkType in MOBILE_SDK_TYPES_MAP) {
				acc.push({
					value: sdkType,
					label: MOBILE_SDK_TYPES_MAP[sdkType as MobileSdkTypesIds]
				});
			}
			return acc;
		}, [])
		.sort((a, b) => naturalSort(a.label, b.label));
};

export const transformMobileSdkFilterOptionsResults = (
	rawResults: MobileSdkFilterOptionsQuery
): IMobileSdkFilterOptions => {
	const runs = (rawResults.msdk_report_runs || []).filter(Boolean);

	if (!runs.length) {
		return {
			appName: [],
			appVersion: [],
			sdkType: [],
			sdkVersion: []
		};
	}

	const allAppNames = getUniqueValues(
		runs.flatMap((run) => toStringArray(run?.app)).filter(Boolean)
	);
	const allAppVersions = getUniqueValues(
		runs.flatMap((run) => toStringArray(run?.app_version)).filter(Boolean)
	);
	const allSdkTypes = getUniqueValues(
		runs.flatMap((run) => toStringArray(run?.sdk_type)).filter(Boolean)
	);
	const allSdkVersions = getUniqueValues(
		runs.flatMap((run) => toStringArray(run?.product_version)).filter(Boolean)
	);

	return {
		appName: createSortedOptions(allAppNames),
		appVersion: createSortedOptions(allAppVersions),
		sdkType: createSdkTypeOptions(allSdkTypes),
		sdkVersion: createSortedOptions(allSdkVersions)
	};
};
